import React, { FunctionComponent } from "react";
import { ReactSelectOption } from "src/lib/globalTypes";
import Dropdown from "../Dropdown";

type SortDropdownProps = {
  options: ReactSelectOption[];
  value: ReactSelectOption;
  onChange: (option: ReactSelectOption) => void;
};

const SortDropdown: FunctionComponent<SortDropdownProps> = ({
  options,
  value,
  onChange,
}) => {
  return (
    <div className="sort-dropdown">
      <span className="input-label">ORDER BY</span>
      <Dropdown
        options={options}
        value={value}
        isSearchable={false}
        onChange={onChange}
      />
    </div>
  );
};

export default SortDropdown;
